module.exports = __webpack_public_path__ + "media/svg-new/no-icon-f8d4b666.svg";